import { render, staticRenderFns } from "./toggle-button.vue?vue&type=template&id=1803f542&scoped=true&"
import script from "./toggle-button.vue?vue&type=script&lang=js&"
export * from "./toggle-button.vue?vue&type=script&lang=js&"
import style0 from "./toggle-button.vue?vue&type=style&index=0&id=1803f542&lang=scss&"
import style1 from "./toggle-button.vue?vue&type=style&index=1&id=1803f542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803f542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1803f542')) {
      api.createRecord('1803f542', component.options)
    } else {
      api.reload('1803f542', component.options)
    }
    module.hot.accept("./toggle-button.vue?vue&type=template&id=1803f542&scoped=true&", function () {
      api.rerender('1803f542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/toggle-button.vue"
export default component.exports